import { type Polygon } from 'geojson';
import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import WeatherMeasurepoint from '../PopupTemplates/WeatherMeasurepoint';
import { WeatherMeasurepointSource } from '../Sources/WeatherMeasurepoint';

export const weatherMeasurepoint = function (regionExtent: Polygon, options?: ClusteredMarkerLayerOptions): ClusteredMarkerLayer {
    const defaultOptions: ClusteredMarkerLayerOptions = {
        name: 'Vägväderstation',
        itemPlural: 'vägväderstationer',
        source: new WeatherMeasurepointSource(regionExtent, {
            updateInterval: 60,
        }),
        popupTemplate: WeatherMeasurepoint,
    };

    return new ClusteredMarkerLayer({ ...defaultOptions, ...options });
};
